import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiEventHubPluginKey = new PluginKey('aiEventHub');
